import React, { useEffect, useRef, useState } from "react";
import { DayPilot, DayPilotScheduler } from "daypilot-pro-react";
import Subheader from "./subheader";
import {
  getService,
  PostServiceWithFile,
} from "../../services/genericPostService";
import moment from "moment";
import { resources_EN } from "../componentUtils";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Path } from "../../RoutesUtils";
import Header from "../header/header";
// import chevronLeft from "../../images/chevron-left.svg"
// import chevronRight from "../../images/chevron-right.svg"
const Scheduler = () => {
  const [timesheet, setTimesheet] = useState(null);
  const [events, setEvents] = useState([]);
  const [showBusinessOnly, setShowBusinessOnly] = useState(false);
  const [showDailyTotals, setShowDailyTotals] = useState(false);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD")); // Initial date
  const [rowHeaderColumns, setRowHeaderColumns] = useState([
    { title: "Date" },
    { title: "Day", width: 40 },
  ]);
  const [file, setFile] = useState("");
  const imageFile = useRef(null);
  const userId = localStorage.getItem("userId");
  const imageRef = useRef(null);

  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      navigate(Path.login);
    }
  }, []);

  const changeMonth = (direction) => {
    const current = new DayPilot.Date(startDate);
    const newDate =
      direction === "next"
        ? current.addMonths(1) // Go forward 1 month
        : current.addMonths(-1); // Go backward 1 month
    setStartDate(newDate.toString("yyyy-MM-dd"));
  };

  const changeYear = (direction) => {
    const current = new DayPilot.Date(startDate);
    const newDate =
      direction === "next"
        ? current.addYears(1) // Go forward 1 year
        : current.addYears(-1); // Go backward 1 year
    setStartDate(newDate.toString("yyyy-MM-dd"));
  };
  const config = {
    locale: "en-us",
    onBeforeRowHeaderRender: (args) => {
      args.row.columns[0].horizontalAlignment = "center";
      args.row.columns[1].text = args.row.start.toString("ddd");
      if (args.row.columns[2]) {
        args.row.columns[2].text = args.row.events
          .totalDuration()
          .toString("h:mm");
      }
    },
    onBeforeEventRender: (args) => {
      const duration = new DayPilot.Duration(args.data.start, args.data.end);
      const startTime = new DayPilot.Date(args.data.start).toString("hh:mm tt");
      const endTime = new DayPilot.Date(args.data.end).toString("hh:mm tt");
      const timeRange = `${startTime} - ${endTime}`;

      args.data.areas = [
        {
          top: 5,
          left: 5,
          text: timeRange, // Time Range at the Top
          fontColor: "#888",
        },
        {
          top: 25,
          left: 5,
          text: args.data.text, // Task Title
          fontColor: "#000",
        },
        {
          top: 45,
          left: 5,
          text: args.data.contact ? `Contact: ${args.data.contact}` : "",
          fontColor: "#888",
        },
      ];
      args.data.html = "";
    },
    cellWidthSpec: "Auto",
    cellWidthMin: 25,
    timeHeaders: [{ groupBy: "Hour" }, { groupBy: "Cell", format: "mm" }],
    scale: "CellDuration",
    cellDuration: 15,
    eventHeight: 65,
    heightSpec: "Max",
    height: 450,
    viewType: "Days",
    startDate: startDate, // Set to a broader range
    days: 31, // Display the entire year
    allowEventOverlap: false,
    timeRangeSelectedHandling: "Enabled",
    onTimeRangeSelected: async (args) => {
      const timesheet = args.control;
      console.log(timesheet);
      const form = [
        { name: "Title", id: "text" },
        { name: "Start", id: "start", type: "datetime" },
        {
          name: "End",
          id: "end",
          type: "datetime",
          onValidate: (args) => {
            if (args.values.end.getTime() < args.values.start.getTime()) {
              args.valid = false;
              args.message = "End must be after start";
            }
          },
        },
        { name: "Description", id: "desc", type: "textarea" },

        {
          name: "Task_Image",
          id: "img",
          type: "html",
          html: `<input type='file' onchange='handleReactFileUpload(event)'  />`,
        },
      ];

      const data = {
        id: DayPilot.guid(),
        start: args.start,
        end: args.end,
        text: "New task",
        contact: "Enter contact info",
      };

      const options = { locale: "en-us" };
      const modal = await DayPilot.Modal.form(form, data, options);
      timesheet.clearSelection();

      if (modal.canceled) return;
      console.log("Modal", modal);
      const submission = submit(modal.result);
      if (submission) {
        timesheet.events.add(modal.result);
      }
    },
  };

  window.handleReactFileUpload = (event) => {
    onclick(event);
  };

  const onclick = (event) => {
    const file = event.target.files[0];
    imageFile.current = file;
    setFile(file);
  };

  useEffect(() => {
    if (!timesheet) {
      return;
    }

    const firstDay = new DayPilot.Date(moment().format("YYYY-MM-DD"));
    timesheet.scrollTo(firstDay.addHours(9));
  }, [timesheet]);

  useEffect(() => {
    getSchedule();
  }, []);

  const getSchedule = () => {
    const data = {
      user_id: userId,
    };
    const url = "/fmeApi/get_schedule.php";
    getService(url, data, setData);
  };

  const setData = (response) => {
    let data = [...response.schedule];
    data = data.map((val) => {
      return {
        ...val,
        id: val.sched_id,
        text: val.sched_name,
        start: moment(val.sched_start_time).format("YYYY-MM-DDTHH:mm:ss"),
        end: moment(val.sched_end_time).format("YYYY-MM-DDTHH:mm:ss"),
        description: val.sched_desc,
      };
    });
    setEvents(data);
  };

  /* Error or Success Modal */
  const modal = (icon, title, message) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: message,
    }).then((response) => {
      if (response.isConfirmed && icon === resources_EN.success) {
        console.log("Success");
        imageFile.current = "";
        getSchedule();
      }
    });
  };

  const submit = (response) => {
    const validate = validation(response);
    console.log("File", file);
    if (validate) {
      const startDate = moment(response.start.value).format("YYYY-MM-DD");
      console.log("Submit", response);

      const data = new FormData();
      data.append("sched_date", startDate);
      data.append("sched_title", response.text);
      data.append("sched_description", response.desc);
      data.append("sched_file", imageFile.current); // Correct way to attach a file
      data.append("sched_start_time", response.start.value);
      data.append("sched_end_time", response.end.value);
      data.append("user_id", userId);

      const url = "/fmeApi/add_schedule.php";
      PostServiceWithFile(url, data, modal);
    }
    return validate;
  };

  const validation = (response) => {
    if (response.text.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyScheduleTitleValidation
      );
      return false;
    }
    if (response.desc.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyScheduleDescValidation
      );
      return false;
    }
    if (imageFile && imageFile.current && imageFile.current === "") {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyScheduleFileValidation
      );
      return false;
    }
    if (response.start.value.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyScheduleStartDate
      );
      return false;
    }
    if (response.end.value.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyScheduleEndDate
      );
      return false;
    }

    return true;
  };
  console.log("Ref", imageFile);
  return (
    <>
      <Header />
      <Subheader
        onPrevYear={() => changeYear("prev")}
        onNextYear={() => changeYear("next")}
      />
      <div className="flex justify-center gap-4 items-center">
        <button
          className="rounded-full bg-theme hover:bg-[#2bbaf0b8]"
          onClick={() => changeMonth("prev")}
        >
          {/*  <img src={chevronLeft} className="w-7 h-7 p-1" alt="" /> */}
        </button>
        <h2 className="text-lg font-bold text-center my-4">
          {new DayPilot.Date(startDate).toString("MMMM yyyy")}
        </h2>
        <button
          className="rounded-full bg-theme hover:bg-[#2bbaf0b8]"
          onClick={() => changeMonth("next")}
        >
          {/* <img src={chevronRight} className="w-7 h-7 p-1" alt="" /> */}
        </button>
      </div>

      <section className="container mx-auto lg:px-8 px-4">
        <DayPilotScheduler
          {...config}
          showNonBusiness={!showBusinessOnly}
          rowHeaderColumns={rowHeaderColumns}
          events={events}
          controlRef={setTimesheet}
        />
      </section>
    </>
  );
};

export default Scheduler;
